<template>
  <a-table
    :rowKey="record => record.id"
    :columns="columns"
    :dataSource="data"
    :scroll="{ x: 5500 }"
    bordered
  >
    <template slot="Serial">{{ $t('business.label.serial') }}</template>
    <template slot="Storer.name">{{ $t('business.label.storerName') }}</template>
    <template slot="Item.name">{{ $t('business.label.itemName') }}</template>
    <template slot="Item.no">{{ $t('business.label.itemNo') }}</template>
    <template slot="MnemonicCode">{{ $t('business.label.mnemonicCode') }}</template>
    <template slot="EnglishName">{{ $t('business.label.englishName') }}</template>
    <template slot="UniversalName">{{ $t('business.label.universalName') }}</template>
    <template slot="Manufacturer">{{ $t('business.label.manufacturer') }}</template>
    <template slot="ProducingArea">{{ $t('business.label.producingArea') }}</template>
    <template slot="Approval">{{ $t('business.label.approvalNo') }}</template>
    <template slot="ApprovalValidUntil">{{ $t('business.label.approvalValidUntil') }}</template>
    bh
    <template slot="ItemType.name">{{ $t('business.label.itemType') }}</template>
    <template slot="ItemCategory.name">{{ $t('business.label.itemCategory') }}</template>
    <template slot="StorageRequest.name">{{ $t('business.label.storageRequest') }}</template>
    <template slot="PositionType.name">{{ $t('business.label.positionType') }}</template>
    <template slot="SupervisingBarcodeInitial">{{ $t('business.label.supervisingBarcodeInitial') }}</template>
    <template slot="SupervisingBarcodeLength">{{ $t('business.label.supervisingBarcodeLength') }}</template>

    <template slot="SaleClassification">{{ $t('business.label.saleClassification') }}</template>
    <template slot="StorageEnvironment">{{ $t('business.label.storageEnvironment') }}</template>
    <template slot="TurnoverMode">{{ $t('business.label.inventoryTurnoverMode') }}</template>
    <template slot="StorageClassification">{{ $t('business.label.storageClassification') }}</template>
    <template slot="Deviation">{{ $t('business.label.deviation') }}</template>
    <template slot="DaysOfExpirationNearly">{{ $t('business.label.daysOfExpirationNearly') }}</template>
    <template slot="DaysOfProductionNearly">{{ $t('business.label.daysOfProductionNearly') }}</template>
    <template slot="DaysOfInspectionNearly">{{ $t('business.label.daysOfInspectionNearly') }}</template>
    <template slot="CostPrice">{{ $t('business.label.costPrice') }}</template>
    <template slot="RetailPrice">{{ $t('business.label.retailPrice') }}</template>
    <template slot="WholesalePrice">{{ $t('business.label.wholesalePrice') }}</template>

    <template slot="Supervised">{{ $t('business.label.supervised') }}</template>
    <template slot="Importation">{{$t('business.label.importation')}}</template>
    <template slot="Valuable">{{ $t('business.label.valuable') }}</template>

    <template slot="ColdChains">{{ $t('business.label.coldChains') }}</template>
    <template slot="Controlled">{{ $t('business.label.controlled') }}</template>
    <template slot="Duplex">{{ $t('business.label.duplex') }}</template>
    <template slot="NewProduct">{{ $t('business.label.newProduct') }}</template>
    <template slot="Approved">{{ $t('business.label.approved') }}</template>
    <template slot="Available">{{ $t('business.label.available') }}</template>


    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
    </span>
    <span slot="saleClassification" slot-scope="text">
      <span
        v-for="(value,key) in saleClassificationData"
        :key="key">
        <span v-if="text===value.ordinal">{{ value.name }}</span>
      </span>
    </span>

    <span slot="storageEnvironment" slot-scope="text">
      <span
        v-for="(value,key) in storageEnvironmentData"
        :key="key">
        <span v-if="text===value.ordinal">{{ value.name }}</span>
      </span>
    </span>

    <span slot="turnoverMode" slot-scope="text">
      <span
        v-for="(value,key) in turnoverModeData"
        :key="key">
        <span v-if="text===value.ordinal">{{ value.name }}</span>
      </span>
    </span>

    <span slot="storageClassification" slot-scope="text">
      <span
        v-for="(value,key) in storageClassificationData"
        :key="key">
        <span v-if="text===value.ordinal">{{ value.name }}</span>
      </span>
    </span>

    <span slot="supervised" slot-scope="text">
      <a-checkbox :checked="text"/>
    </span>

    <span slot="importation" slot-scope="text">
      <a-checkbox :checked="text"/>
    </span>

    <span slot="valuable" slot-scope="text">
      <a-checkbox :checked="text"/>
    </span>
    <span slot="coldChains" slot-scope="text">
      <a-checkbox :checked="text"/>
    </span>
    <span slot="controlled" slot-scope="text">
      <a-checkbox :checked="text"/>
    </span>
    <span slot="duplex" slot-scope="text">
      <a-checkbox :checked="text"/>
    </span>
    <span slot="newProduct" slot-scope="text">
      <a-checkbox :checked="text"/>
    </span>
    <span slot="approved" slot-scope="text">
      <a-checkbox :checked="text"/>
    </span>
    <span slot="available" slot-scope="text">
      <a-checkbox :checked="text"/>
    </span>


    <!--根据商品名称/编号/助记码过滤-->
    <div
      slot="filterDropdown"
      slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
      style="padding: 8px"
    >
      <a-input
        v-ant-ref="c => searchInput = c"
        :value="selectedKeys[0]"
        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
        @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
        style="width: 188px; margin-bottom: 8px; display: block;"
      />
      <a-button
        type="primary"
        @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
        icon="search"
        size="small"
        style="width: 90px; margin-right: 8px">{{ $t('button.query') }}
      </a-button>
      <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">{{ $t('button.reset') }}
      </a-button>
    </div>
    <a-icon
      slot="filterIcon"
      slot-scope="filtered"
      type="search"
      :style="{ color: filtered ? '#108ee9' : undefined }"/>
    <template slot="search" slot-scope="text, record, index, column">
      <span v-if="searchText && searchedColumn === column.dataIndex">
        <template
          v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
        >
          <mark
            v-if="fragment.toLowerCase() === searchText.toLowerCase()"
            :key="i"
            class="highlight"
          >{{ fragment }}</mark
          >
          <template
            v-else
          >{{ fragment }}</template
          >
        </template>
      </span>
      <template
        v-else
      >{{ text }}
      </template
      >
    </template>

  </a-table>
</template>

<script>
import { findAll, findOne } from '@/api/Api'
  import {exportToExcel} from '@/components/Excel/export/exportFunction'
  import {nameToEntity, nameToOrdinal, ordinalToName, transformData} from '@/api/dto_js/import/transform'
  import {excelName, filterVal, headerData} from '@/api/dto_js/import/itemBaseData'
  import {checkFieldType} from '@/utils/field-check'

  export default {
    name: 'ItemBaseData',
    data() {
      return {
        data: [],
        // 表头
        columns: [
          {
            // fixed: 'left',
            scopedSlots: {customRender: 'serial', title: 'Serial'}
          },
          {

            dataIndex: 'storer.name',
            scopedSlots: {title: 'Storer.name'}
          },
          {
            dataIndex: 'no',
            scopedSlots: {
              customRender: 'search',
              title: 'Item.no',
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            },
            onFilter: (value, record) => record.no.toString().toLowerCase().includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            dataIndex: 'name',
            scopedSlots: {
              customRender: 'search',
              title: 'Item.name',
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            },
            onFilter: (value, record) => record.name.toString().toLowerCase().includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            dataIndex: 'mnemonicCode',
            scopedSlots: {
              customRender: 'search',
              title: 'MnemonicCode',
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            },
            onFilter: (value, record) => record.mnemonicCode.toString().toLowerCase().includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            dataIndex: 'englishName',
            scopedSlots: {title: 'EnglishName'}
          },
          {
            dataIndex: 'universalName',
            scopedSlots: {title: 'UniversalName'}
          },
          {
            dataIndex: 'manufacturer',
            scopedSlots: {title: 'Manufacturer'}
          },
          {
            dataIndex: 'producingArea',
            scopedSlots: {title: 'ProducingArea'}
          },
          {

            dataIndex: 'approval',
            scopedSlots: {title: 'Approval'}
          },
          {

            dataIndex: 'approvalValidUntil',
            scopedSlots: {title: 'ApprovalValidUntil'}
          },
          {
            dataIndex: 'itemType.name',
            scopedSlots: {title: 'ItemType.name'}
          },
          {

            dataIndex: 'itemCategory.name',
            scopedSlots: {title: 'ItemCategory.name'}
          },
          {
            dataIndex: 'storageRequest.name',
            scopedSlots: {title: 'StorageRequest.name'}
          },
          {
            dataIndex: 'positionType.name',
            scopedSlots: {title: 'PositionType.name'}
          },
          {
            dataIndex: 'supervisingBarcodeInitial',
            scopedSlots: {title: 'SupervisingBarcodeInitial'}
          },
          {
            dataIndex: 'supervisingBarcodeLength',
            scopedSlots: {title: 'SupervisingBarcodeLength'}
          },

          {
            dataIndex: 'saleClassification',
            scopedSlots: {customRender: 'saleClassification', title: 'SaleClassification'}
          },
          {
            dataIndex: 'storageEnvironment',
            scopedSlots: {customRender: 'storageEnvironment', title: 'StorageEnvironment'}
          },
          {
            dataIndex: 'turnoverMode',
            scopedSlots: {customRender: 'turnoverMode', title: 'TurnoverMode'}
          },
          {
            dataIndex: 'storageClassification',
            scopedSlots: {customRender: 'storageClassification', title: 'StorageClassification'}
          },
          {
            dataIndex: 'deviation',
            scopedSlots: {title: 'Deviation'}
          },
          {
            dataIndex: 'daysOfExpirationNearly',
            scopedSlots: {title: 'DaysOfExpirationNearly'}
          },
          {
            dataIndex: 'daysOfProductionNearly',
            scopedSlots: {title: 'DaysOfProductionNearly'}
          },
          {
            dataIndex: 'daysOfInspectionNearly',
            scopedSlots: {title: 'DaysOfInspectionNearly'}
          },
          {
            dataIndex: 'costPrice',
            scopedSlots: {title: 'CostPrice'}
          },
          {
            dataIndex: 'retailPrice',
            scopedSlots: {title: 'RetailPrice'}
          },
          {
            dataIndex: 'wholesalePrice',
            scopedSlots: {title: 'WholesalePrice'}
          },

          {
            dataIndex: 'supervised',
            scopedSlots: {customRender: 'supervised', title: 'Supervised'}
          },
          {
            dataIndex: 'importation',
            scopedSlots: { customRender: 'importation', title: 'Importation' }
          },
          {

            dataIndex: 'valuable',
            scopedSlots: {customRender: 'valuable', title: 'Valuable'}
          },
          {
            dataIndex: 'coldChains',
            scopedSlots: {customRender: 'coldChains', title: 'ColdChains'}
          },
          {
            dataIndex: 'controlled',
            scopedSlots: {customRender: 'controlled', title: 'Controlled'}
          },
          {
            dataIndex: 'duplex',
            scopedSlots: {customRender: 'duplex', title: 'Duplex'}
          },
          {
            dataIndex: 'newProduct',
            scopedSlots: {customRender: 'newProduct', title: 'NewProduct'}
          },
          {
            dataIndex: 'approved',
            scopedSlots: {customRender: 'approved', title: 'Approved'}
          },
          {
            dataIndex: 'available',
            scopedSlots: {customRender: 'available', title: 'Available'}
          }


        ],
        excelData: [],
        storerData: [],
        itemTypeData: [],
        saleClassifications: [],
        storageEnvironmentData: [],
        turnoverModeData: [],
        storageClassificationData: [],
        itemCategoryData: [],
        storageRequestData: [],
        positionTypeData: [],
        searchText: '',
        searchInput: null,
        searchedColumn: ''
      }
    },
    created() {
      findAll('storerFactory', {}).then(body => {
        body.forEach(item => {
          this.storerData.push(item)
        })
      })
      findAll('fieldFactory', { no: 'ITEM_TYPE' }).then(body => {
        body.dictionaries.forEach(item => {
          this.itemTypeData.push(item)
        })
      })
      findAll('fieldFactory', {no: 'SALE_CLASSIFICATION'}).then(body => {
        body.dictionaries.forEach(item => {
          this.saleClassifications.push(item)
        })
      })
      findAll('fieldFactory', {no: 'STORAGE_ENVIRONMENT'}).then(body => {
        body.dictionaries.forEach(item => {
          this.storageEnvironmentData.push(item)
        })
      })
      findAll('fieldFactory', {no: 'TURNOVER_MODE'}).then(body => {
        body.dictionaries.forEach(item => {
          this.turnoverModeData.push(item)
        })
      })
      findAll('fieldFactory', {no: 'STORAGE_CLASSIFICATION'}).then(body => {
        body.dictionaries.forEach(item => {
          this.storageClassificationData.push(item)
        })
      })
      findOne('parameterFactory', { name: '商品类别层级' }).then(res => {
        if (res.success) {
          findOne('fieldFactory', { no: res.result.value }).then(res => {
            if (res.success && res.result.dictionaries.length > 0) {
              this.itemCategoryData = res.result.dictionaries
            }
          })
        }
      })
      findAll('fieldFactory', {no: 'STORAGE_REQUEST'}).then(body => {
        body.dictionaries.forEach(item => {
          this.storageRequestData.push(item)
        })
      })
      findAll('fieldFactory', {no: 'POSITION_TYPE'}).then(body => {
        body.dictionaries.forEach(item => {
          this.positionTypeData.push(item)
        })
      })
    },
    methods: {
      getData(data) {
        this.data = data
      },
      handleSearch(selectedKeys, confirm, dataIndex) {
        confirm()
        this.searchText = selectedKeys[0]
        this.searchedColumn = dataIndex
      },
      handleReset(clearFilters) {
        clearFilters()
        this.searchText = ''
      },
      exportData() {
        const excelData = JSON.parse(JSON.stringify(this.data))
        for (let x = 0; x < excelData.length; x++) {
          if (excelData[x].storer) {
            excelData[x].storer = excelData[x].storer.name
          }
          if (excelData[x].itemType) {
            excelData[x].itemType = excelData[x].itemType.name
          }
          if (excelData[x].itemCategory) {
            excelData[x].itemCategory = excelData[x].itemCategory.name
          }
          if (excelData[x].storageRequest) {
            excelData[x].storageRequest = excelData[x].storageRequest.name
          }
          if (excelData[x].positionType) {
            excelData[x].positionType = excelData[x].positionType.name
          }
          //显示为ordinal，转换为name显示然后导出
          excelData[x] = ordinalToName(excelData[x], 'saleClassification', this.saleClassifications)
          excelData[x] = ordinalToName(excelData[x], 'storageEnvironment', this.storageEnvironmentData)
          excelData[x] = ordinalToName(excelData[x], 'turnoverMode', this.turnoverModeData)
          excelData[x] = ordinalToName(excelData[x], 'storageClassification', this.storageClassificationData)
        }
        exportToExcel(headerData, filterVal, excelData, excelName)
      },
      transformData(data) {
        // storer  itemType尚未转换
        const list = transformData(headerData, filterVal, data)
        for (let i = 0; i < list.length; i++) {
          // if(list[i].storer){
          //   list[i].storer={name:list[i].storer}
          // }
          // if(list[i].itemType){
          //   list[i].itemType={name:list[i].itemType}
          // }
          list[i] = nameToEntity(list[i], 'storer', this.storerData)
          list[i] = nameToEntity(list[i], 'itemType', this.itemTypeData)
          list[i] = nameToEntity(list[i], 'itemCategory', this.itemCategoryData)
          list[i] = nameToEntity(list[i], 'storageRequest', this.storageRequestData)
          list[i] = nameToEntity(list[i], 'positionType', this.positionTypeData)
          list[i] = nameToOrdinal(list[i], 'saleClassification', this.saleClassifications)
          list[i] = nameToOrdinal(list[i], 'storageEnvironment', this.storageEnvironmentData)
          list[i] = nameToOrdinal(list[i], 'turnoverMode', this.turnoverModeData)
          list[i] = nameToOrdinal(list[i], 'storageClassification', this.storageClassificationData)
        }
        // this.$message.info(JSON.stringify(list))
        this.data = list
      },
      save() {

        const arrItem = []

        this.data.forEach(item => {
          item['id'] = null
          item['version'] = 0

          const map = new Map()
          map.set('type', 'itemPersister')
          map.set('dataId', item.no)
          map.set('content', item)
          const returnValue = checkFieldType(map)
          arrItem.push(returnValue)
        })
        // this.$message.info(JSON.stringify(this.data))
        this.$emit('sendSave', arrItem)
      },
      clear() {
        this.data = []
      }
    }
  }
</script>

<style scoped>
  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>